import React from 'react';

// ui
import { SvgIcon, SvgIconProps } from '@domonda/ui/SvgIcon';

// icons
import DashboardSvg from 'material-icons-svg/icons/sharp-dashboard-24px.svg';
import DocumentsSvg from './documentSvg.svg';
import AddDocumentSvg from 'material-icons-svg/icons/sharp-add_circle-24px.svg';
import DownloadDocumentSvg from 'material-icons-svg/icons/sharp-cloud_download-24px.svg';
import RemoveDocumentSvg from 'material-icons-svg/icons/sharp-delete-24px.svg';
import PreviousDocumentSvg from 'material-icons-svg/icons/sharp-arrow_back-24px.svg';
import NextDocumentSvg from 'material-icons-svg/icons/sharp-arrow_forward-24px.svg';
import CloseDocumentSvg from 'material-icons-svg/icons/sharp-close-24px.svg';
import AdjustViewSvg from 'material-icons-svg/icons/sharp-settings-24px.svg';
import SearchSvg from './searchSvg.svg';
import ApproveDocumentSvg from './checkmark.svg';
import ZoomInDocumentSvg from 'material-icons-svg/icons/sharp-zoom_in-24px.svg';
import ZoomOutDocumentSvg from 'material-icons-svg/icons/sharp-zoom_out-24px.svg';
import FullscreenSvg from 'material-icons-svg/icons/sharp-fullscreen-24px.svg';
import FullscreenExitSvg from 'material-icons-svg/icons/sharp-fullscreen_exit-24px.svg';
import AccordionToggleSvg from 'material-icons-svg/icons/sharp-expand_more-24px.svg';
import GridOnSvg from 'material-icons-svg/icons/sharp-grid_on-24px.svg';
import GridOffSvg from 'material-icons-svg/icons/sharp-grid_off-24px.svg';
import ArrowLeftSvg from 'material-icons-svg/icons/sharp-keyboard_arrow_left-24px.svg';
import ArrowRightSvg from 'material-icons-svg/icons/sharp-keyboard_arrow_right-24px.svg';
import ClearSvg from 'material-icons-svg/icons/sharp-clear-24px.svg';
import CallSplitSvg from 'material-icons-svg/icons/sharp-call_split-24px.svg';
import UnfoldLessSvg from 'material-icons-svg/icons/sharp-unfold_less-24px.svg';
import UnfoldMoreSvg from 'material-icons-svg/icons/sharp-unfold_more-24px.svg';
import PublishSvg from 'material-icons-svg/icons/sharp-publish-24px.svg';
import DoneAllSvg from 'material-icons-svg/icons/sharp-done_all-24px.svg';
import PowerSvg from 'material-icons-svg/icons/sharp-power_settings_new-24px.svg';
import LanguageSvg from 'material-icons-svg/icons/sharp-language-24px.svg';
import AccountSvg from 'material-icons-svg/icons/sharp-account_circle-24px.svg';
import ImageSearchSvg from 'material-icons-svg/icons/sharp-image_search-24px.svg';
import UndoSvg from 'material-icons-svg/icons/sharp-undo-24px.svg';
import EditSvg from 'material-icons-svg/icons/sharp-edit-24px.svg';
import ArrowDownIcon from './arrowDown.svg';
import UploadIconSvg from './upload.svg';
import SettingSvg from './settingIcon.svg';
import ToggleSvg from './toggleBtn.svg';
import NavigationArrowSvg from './navigationArrow.svg';
import HamburgerIconSvg from './hamburgerIcon.svg';
import FeatureRequestSvg from './featureRequest.svg';
import ClosePopUpSvg from './closeBtn.svg';
import LoadingSVG from './loading.svg';
import DashboarIcondSvg from './dashboard.svg';
import DropdownArrowDownSvg from './dropdownArrow.svg';
import JsonSvg from './json.svg';


export const DropdownArrowDown: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: DropdownArrowDownSvg }} />
  </SvgIcon>
);
export const DashboardIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: DashboarIcondSvg }} />
  </SvgIcon>
);
export const LoadingCircle: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: LoadingSVG }} />
  </SvgIcon>
);
export const ClosePopUp: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: ClosePopUpSvg }} />
  </SvgIcon>
);
export const FeatureRequestIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: FeatureRequestSvg }} />
  </SvgIcon>
);
export const NavigationArrowIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: NavigationArrowSvg }} />
  </SvgIcon>
);
export const HamburgerIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: HamburgerIconSvg }} />
  </SvgIcon>
);
export const ToggleIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: ToggleSvg }} />
  </SvgIcon>
);
export const UploadIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: UploadIconSvg }} />
  </SvgIcon>
);
export const SettingIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: SettingSvg }} />
  </SvgIcon>
);
export const Dashboard: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: DashboardSvg }} />
  </SvgIcon>
);
export const Documents: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: DocumentsSvg }} />
  </SvgIcon>
);
export const AddDocument: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: AddDocumentSvg }} />
  </SvgIcon>
);
export const DownloadDocument: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: DownloadDocumentSvg }} />
  </SvgIcon>
);
export const RemoveDocument: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: RemoveDocumentSvg }} />
  </SvgIcon>
);
export const PreviousDocument: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: PreviousDocumentSvg }} />
  </SvgIcon>
);
export const NextDocument: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: NextDocumentSvg }} />
  </SvgIcon>
);
export const CloseDocument: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: CloseDocumentSvg }} />
  </SvgIcon>
);
export const ApproveDocument: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: ApproveDocumentSvg }} />
  </SvgIcon>
);

export const AdjustView: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: AdjustViewSvg }} />
  </SvgIcon>
);
export const ZoomInDocument: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: ZoomInDocumentSvg }} />
  </SvgIcon>
);
export const ZoomOutDocument: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: ZoomOutDocumentSvg }} />
  </SvgIcon>
);
export const Fullscreen: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: FullscreenSvg }} />
  </SvgIcon>
);
export const FullscreenExit: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: FullscreenExitSvg }} />
  </SvgIcon>
);
export const Search: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: SearchSvg }} />
  </SvgIcon>
);
export const AccordionToggle: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: AccordionToggleSvg }} />
  </SvgIcon>
);
export const GridOn: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: GridOnSvg }} />
  </SvgIcon>
);
export const GridOff: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: GridOffSvg }} />
  </SvgIcon>
);
export const ArrowLeft: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: ArrowLeftSvg }} />
  </SvgIcon>
);
export const ArrowRight: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: ArrowRightSvg }} />
  </SvgIcon>
);
export const ClearIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: ClearSvg }} />
  </SvgIcon>
);
export const SplitIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: CallSplitSvg }} />
  </SvgIcon>
);
export const UnfoldLessIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: UnfoldLessSvg }} />
  </SvgIcon>
);
export const UnfoldMoreIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: UnfoldMoreSvg }} />
  </SvgIcon>
);
export const PublishIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: PublishSvg }} />
  </SvgIcon>
);
export const DoneAllIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: DoneAllSvg }} />
  </SvgIcon>
);
export const PowerIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: PowerSvg }} />
  </SvgIcon>
);
export const LanguageIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: LanguageSvg }} />
  </SvgIcon>
);
export const AccountIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: AccountSvg }} />
  </SvgIcon>
);
export const ImageSearchIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: ImageSearchSvg }} />
  </SvgIcon>
);
export const UndoIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: UndoSvg }} />
  </SvgIcon>
);
export const EditIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: EditSvg }} />
  </SvgIcon>
);
export const ArrowDown: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: ArrowDownIcon }} />
  </SvgIcon>
);
export const Json: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: JsonSvg }} />
  </SvgIcon>
);
